import {
  AGENT_PREFERENCES,
  CHANGE_AGENT_PREFERENCE,
  GET_AGENT_PREFERENCE,
} from '../types';

import { Agents } from '@/api/api';

export const state = () => ({
  preferences: {},
});

export const getters = {
  [AGENT_PREFERENCES]({ preferences }) {
    return preferences;
  },
  [GET_AGENT_PREFERENCE]: ({ preferences }) => (packageName, preference) => {
    const packagesPrefrences = preferences[preference];
    if (!packagesPrefrences || packagesPrefrences[packageName] === undefined) {
      return null;
    }
    return packagesPrefrences[packageName];
  },
};

export const mutations = {
  [AGENT_PREFERENCES](stateObj, preferences) {
    stateObj.preferences = {};

    for (const preference of preferences) {
      const name = preference.preference;
      const { apps } = preference.value;

      stateObj.preferences[name] = {};

      for (const app of apps) {
        stateObj.preferences[name][app.name] = app.value;
      }
    }
  },
  [CHANGE_AGENT_PREFERENCE](stateObj, { name, app, value }) {
    if (!stateObj.preferences[name]) return;

    stateObj.preferences[name][app] = value;
  },
};

export const actions = {
  [AGENT_PREFERENCES]({ commit }) {
    return Agents.getCurrentAgentPreferences()
      .then(preferences => {
        commit(AGENT_PREFERENCES, preferences);
      })
      .catch(() => {});
  },
  [CHANGE_AGENT_PREFERENCE]({ commit }, { name, app, value }) {
    return Agents.setCurrentAgentPreferences({ name, app, value })
      .then(() => {
        commit(CHANGE_AGENT_PREFERENCE, { name, app, value });
      })
      .catch(() => {});
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
